import type { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Icon } from '@/components/atoms/Icon';
import { HeaderCell } from './HeaderCell';

const isEmptyCell = (children: React.ReactNode) => Array.isArray(children) && !children[0];

export const renderRichTextContentOptions: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (text, children) => {
      if (Array.isArray(children)) {
        const [child] = children;
        if (child?.length === 0) {
          return null;
        }
      }

      return <p>{children}</p>;
    },
    [BLOCKS.TABLE_CELL]: (text, children) => {
      if (isEmptyCell(children)) {
        return <td className="empty-cell">―</td>;
      }

      return <td>{children}</td>;
    },
    [BLOCKS.TABLE_HEADER_CELL]: (text, children) => {
      if (isEmptyCell(children)) {
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        return <th className="empty-header-cell" />;
      }

      return <th>{children}</th>;
    },
  },
  renderText: (text) => {
    try {
      let element: React.ReactNode = text;
      const { icon, title, subtitle, price, ctaText, ctaLink } = JSON.parse(text) || {};

      if (icon) {
        element = <Icon id={icon} />;
        // means that it's header cell
      } else if (title) {
        element = (
          <HeaderCell title={title} subtitle={subtitle} price={price} ctaText={ctaText} ctaLink={ctaLink} />
        );
      }

      return element;
    } catch (error) {
      return text;
    }
  },
};
